import React, { createContext, Dispatch, ReactNode, useCallback, useEffect, useState } from "react";

import { Auth } from "components/types";

const AuthContextState = createContext<{isAuth: boolean, auth: Auth | null, isLoading: boolean}>({isAuth: false, auth: null, isLoading: true});
const AuthContextDispatch = createContext<Dispatch<Auth | null> | null>(null);

interface Props {
    children?: ReactNode,
}

const AuthContextProvider = ({children, ...props}: Props) => {
    const [authState, setAuthState] = useState<Auth | null>(null);
    const [loadingState, setLoadingState] = useState<boolean>(true);

    const setAuth = useCallback((auth: Auth | null) => {
        if (auth) {
            localStorage.setItem('auth', JSON.stringify(auth));
        } else {
            localStorage.removeItem('auth');
        }
        setAuthState(auth);
    }, []);

    useEffect(() => {
        const authData = localStorage.getItem('auth');
        setAuthState(authData ? JSON.parse(authData) : null);
        setLoadingState(false);
    }, []);

    return (
        <AuthContextDispatch.Provider value={setAuth}>
            <AuthContextState.Provider value={{isAuth: authState !== null, auth: authState, isLoading: loadingState}}>
                {children}
            </AuthContextState.Provider>
        </AuthContextDispatch.Provider>
    );
};

export { AuthContextState, AuthContextDispatch, AuthContextProvider };